module.exports = __webpack_public_path__ + "static/media/abdrahem.cef2f949.jpeg";